<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="column">
          <div class="detail-column">Individual Deductible:
            <div class="ml-2">{{ formatNumber(verificationDetails.individualDeductible) }}</div>
          </div>
          <div class="detail-column">Individual Deductible Remaining:
          <div class="ml-2">{{ formatNumber(verificationDetails.individualDeductibleRemaining) }}</div>
          </div>
            <div class="detail-column">Individual Deductible Met:
          <div class="ml-2">{{ formatNumber(verificationDetails.individualDeductibleMet) }}</div></div>
              <div class="detail-column">Individual Max Oop:
          <div class="ml-2">{{ formatNumber(verificationDetails.individualMaxOop) }}</div></div>
                <div class="detail-column">Individual Max Oop Remaining:
          <div class="ml-2">{{ formatNumber(verificationDetails.individualMaxOopRemaining) }}</div></div>
                  <div class="detail-column">Family Deductible:
          <div class="ml-2">{{ formatNumber(verificationDetails.familyDeductible) }}</div></div>
                    <div class="detail-column">Family Deductible Remaining:
          <div class="ml-2">{{ formatNumber(verificationDetails.familyDeductibleRemaining) }}</div></div>
                      <div class="detail-column">Family Max Oop:
          <div class="ml-2">{{ formatNumber(verificationDetails.familyMaxOop) }}</div></div>
                        <div class="detail-column">Family Max Oop Remaining:
          <div class="ml-2">{{ formatNumber(verificationDetails.familyMaxOopRemaining) }}</div>
          </div>
                          <div class="detail-column">Individual CoInsurance:
          <div class="ml-2">{{ formatPercentage(verificationDetails.individualCoInsurance) }}</div></div>
                            <div class="detail-column">Family CoInsurance:
          <div class="ml-2">{{ formatPercentage(verificationDetails.familyCoInsurance) }}</div></div>
        </div>
        </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
    </b-modal>
</template>
<script>

  export default {
    name: 'InsuranceVerificationModal',

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      verificationDetails: {
        type: Object,
        required: false
      },

      title: {
        type: String,
        default: 'Insurance Verification Details'
      }
    },
    methods: {
      formatNumber (number) {
        if (number === 0 || number === 0.0) {
          return '$' + '0.00'
        }
        if (number) {
          return '$' + number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
        return 'N/A'
      },

      formatPercentage (number) {
        if (!number) {
          return ''
        }
        return (number * 100) + '%'
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }

</script>

<style scoped>
.detail-column {
  display: flex;
}
</style>
